var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"upload-demo",attrs:{"action":"","file-list":_vm.fileList,"before-upload":_vm.BeforeUpload,"http-request":_vm.Upload,"on-remove":_vm.beforeRemove}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }